import { render, staticRenderFns } from "./dressup-list.vue?vue&type=template&id=27a7cc7f&scoped=true&"
import script from "./dressup-list.vue?vue&type=script&lang=js&"
export * from "./dressup-list.vue?vue&type=script&lang=js&"
import style0 from "./dressup-list.vue?vue&type=style&index=0&id=27a7cc7f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a7cc7f",
  null
  
)

export default component.exports